export const TARIFF_RECOMMENDATION_REQUEST = 'TARIFF_RECOMMENDATION_REQUEST'
export const TARIFF_RECOMMENDATION_START = 'TARIFF_RECOMMENDATION_START'
export const TARIFF_RECOMMENDATION_SUCCESS = 'TARIFF_RECOMMENDATION_SUCCESS'
export const TARIFF_RECOMMENDATION_FAILURE = 'TARIFF_RECOMMENDATION_FAILURE'
export const TARIFF_RECOMMENDATION_CLEAR = 'TARIFF_RECOMMENDATION_CLEAR'

export interface TariffRecommendationRequestAction {
  type: typeof TARIFF_RECOMMENDATION_REQUEST
  payload: {
    system_uuid: string
  }
}

export interface TariffRecommendationStartAction {
  type: typeof TARIFF_RECOMMENDATION_START
  payload: {
    system_uuid: string
  }
}

export interface TariffRecommendationSuccessAction {
  type: typeof TARIFF_RECOMMENDATION_SUCCESS
  payload: {
    system_uuid: string
    response: any
  }
}

export interface TariffRecommendationFailureAction {
  type: typeof TARIFF_RECOMMENDATION_FAILURE
  payload: {
    system_uuid: string
    error: string
  }
}

export interface TariffRecommendationClearAction {
  type: typeof TARIFF_RECOMMENDATION_CLEAR
  payload: {
    system_uuid?: string // If not provided, clears all
  }
}

export type TariffRecommendationAction =
  | TariffRecommendationRequestAction
  | TariffRecommendationStartAction
  | TariffRecommendationSuccessAction
  | TariffRecommendationFailureAction
  | TariffRecommendationClearAction
